import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Peru Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  analyticsRangeDownloadPresent: true,
  exportPDFInAnalytics: false,
  isViewAllGridNew: true,
  isShipmentGridNew: true,
  showUiTrends: true,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("peruExportLatestArrivalDate"),
    getSearchResult: getApiUrl("peruExportSearch"),
    getAnalyticsData: getApiUrl("analytics/peruExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_peru_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_peru_exports"),
    getShipmentByID: getApiUrl("peruExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfPeruExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/peruExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.pe_export.country_small,
  countryCaps: globalCountryDetails.pe_export.country_caps,
  product_id: globalCountryDetails.pe_export.product_id,
  compare_product_id: globalCountryDetails.pe_export.compareProduct,
  country_CamelCase: globalCountryDetails.pe_export.product_id,
  countryCode: globalCountryDetails.pe_export.countryCode,
  countryType: globalCountryDetails.pe_export.countryType,
  manyCountryType: globalCountryDetails.pe_export.manyCountryType,
  countryTypeCode: globalCountryDetails.pe_export.countryTypeCode,
  redirectionID: globalCountryDetails.pe_export.redirectionID,
  analyticsCountryID: globalCountryDetails.pe_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Declaration Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.pe_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
    portOfUnlading: "standardUnladingPortRegion",
  },
  filterObj: {
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    shipper: "shipper",
    shipperState: "shipperState",
    shipperDepartment: "shipperDepartment",
    shipperDistrict: "shipperDistrict",
    standardLadingPortName: "standardLadingPortName",
    modeOfTransport: "modeOfTransport",
    shipmentValue: "shipmentValue",
    hsCode: "hsCode",
    carrierName: "carrierName",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    weight: "weight",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    standardUnladingPortRegion: "standardUnladingPortName",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    standardUnladingPortRegion: [],
    shipper: [],
    shipperState: [],
    shipperDepartment: [],
    shipperDistrict: [],
    standardLadingPortName: [],
    modeOfTransport: [],
    shipmentValue: [],
    hsCode: [],
    carrierName: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    weight: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    standardUnladingPortRegion: false,
    shipper: false,
    shipperState: false,
    shipperDepartment: false,
    shipperDistrict: false,
    standardLadingPortName: false,
    modeOfTransport: false,
    shipmentValue: false,
    hsCode: false,
    carrierName: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    weight: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "16", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "3", key: "shipper", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Unlading", categoryName: "ports", eventKey: "2", key: "standardUnladingPortRegion", altKey: "standardUnladingPortName", type: filterType.localizeFilter, label: "Port of Unlading", viewAllPlaceHolder: "Search in Port of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper State", categoryName: "shipperDetails", eventKey: "4", key: "shipperState", type: filterType.normalFilter, label: "Shipper State", viewAllPlaceHolder: "Search in Shipper State Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Department", categoryName: "shipperDetails", eventKey: "5", key: "shipperDepartment", type: filterType.normalFilter, label: "Shipper Department", viewAllPlaceHolder: "Search in Shipper Department Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper District", categoryName: "shipperDetails", eventKey: "6", key: "shipperDistrict", type: filterType.normalFilter, label: "Shipper District", viewAllPlaceHolder: "Search in Shipper District Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office", categoryName: "ports", eventKey: "7", key: "standardLadingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "8", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "9", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value (USD) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: "cargoDetails", eventKey: "16", key: "weight", type: filterType.boxFilter, label: "Weight", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "10", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "10", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Carrier Name", categoryName: "carrierDetails", eventKey: "11", key: "carrierName", type: filterType.normalFilter, label: "Carrier Name", viewAllPlaceHolder: "Search in Carrier Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "dua", label: "DUA" },
    { key: "hs_code", label: "HS Code" },
    { key: "shipper_name", label: "Shipper Namer" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "shipment_description_of_goods", label: "Product Description (Spanish)" },
    { key: "derived_product_description_english", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_office_name", label: "Customs Office" },
    { key: "derived_port_of_destination", label: "Port of Destination" },
  ],
  shipmentSorting: [
    { columnKey: "shipment_date", value: "date", isDefault: true },
    { columnKey: "fob_value_item", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "shipment_date",
    shipment_value: "fob_value_item",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "Kg", valuePrefix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "custom", filterKey: "standardLadingPortName", label: "Customs offices", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination", profileType: redirectingProfileEnum.portOfLading.key },
    { key: "port_of_destination", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "carrier_name", filterKey: "carrierName", label: "Carriers", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },
    // { key: "trade_customs_destination_country", filterKey1: "standardLadingPortName", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Customs House -> Country of Import)", headerOne: "Customs House", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "carrier_name" },
    { key: "trade_customs_port", filterKey1: "standardLadingPortName", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Customs House -> Port of Unlading)", headerOne: "Customs House", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "carrier_name" },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "declaration_date", altKey: "shipment_date", name: "Shipment Date", selector: "shipment_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "cargo_description", name: "Product", selector: "cargo_description", tooltipValue: "cargo_description", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 50 },
    { key: "commercial_quantity", name: "Quantity", selector: "commercial_quantity", secondarySelector: "derived_commercial_unit_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "exporter_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true },
    { key: "derived_country_of_destination", name: "Country of Import", selector: "derived_country_of_destination", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "110px", maWidth: "110px" },
    { key: "shipment_value", altKey: "fob_value_item", name: "Shipment Value (USD)", selector: "fob_value_item", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "ruc", showUiUeTwoLevel: false, name: "RUC", selector: "ruc", grow: 1, wrap: true },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "shipment_date", dateFormat: true, monthFormat: false },
        { label: "DUA", value: "dua", capitalize: true },
        { label: "Item No.", value: "itemCount", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "dua", requestNum: "item_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport" },
        { label: "HS Code", value: "hs_code" },
        { label: "Product Keywords", value: "cargo_description", isReadMore: true, readMoreLength: 50 },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper RUC Number", value: "shipper_ruc_number" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "shipper_name", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper address", value: "shipper_address" },
        { label: "Shipper department", value: "shipper_department" },
        { label: "Shipper State", value: "derived_shipper_state" },
        { label: "Shipper district", value: "shipper_district" },
        { label: "Shipper Phone/Fax", value: "shipper_phone" },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "country_of_destination", tooltipPrefix: "Country Code: ", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Port of Unlading", value: "derived_port_of_destination", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs Office", value: "derived_customs_office_name", capitalize: "true", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Customs Agent", value: "customs_office_agent", capitalize: "true" },
      ],
    },
    {
      id: 5,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Carrier Name", value: "derived_carrier_name", capitalize: true },
        { label: "Vessel name", value: "vessel_name", capitalize: true },
      ],
    },
    {
      id: 6,
      title: "DUA Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "DUA Id", value: "dua" },
        { label: "Total FOB Value", value: "fob_value_dua", valuePrefix: "USD" },
        { label: "Net weight DUA", value: "net_weight_dua", valueSuffix: "KG" },
        { label: "Gross weight DUA", value: "gross_weight_dua", valueSuffix: "KG" },
      ],
    },
    {
      id: 7,
      title: "Item Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Item Number", value: "item_number" },
        { label: "Item FOB Value", value: "fob_value_item", valuePrefix: "USD" },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Item Commercial Quantity", value: "commercial_quantity", dynamicUnit: true, unitField: "derived_commercial_unit_english" },
        { label: "Item Quantity", value: "unit_quantity", dynamicUnit: true, unitField: "derived_measurement_unit_english" },
        { label: "Net Weight", value: "net_weight_item", isCommaFormat: true, valueSuffix: " kg" },
        { label: "Gross Weight (kg)", value: "gross_weight_item", isCommaFormat: true, valueSuffix: " kg" },
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 50 },
        { label: "Product Description (Spanish)", value: "cargo_description", isReadMore: true, readMoreLength: 50 },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export -> Country of Import)",
    // derived_consignee_master_name:"Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination: "Countries of Import",
    customs_office: "Customs offices",
    port_of_destination: "Ports of Unlading",
    carrier_name: "Carriers",
    // trade_customs_destination_country: "Trade Routes (Customs House -> Country of Import)",
    trade_customs_port: "Trade Routes (Customs House -> Port of Unlading)",
    derived_mode_of_transport_english: "Mode of Transportation",

    six_digit_hs_code: "6 digit HS Codes",
  },
};

const PeruExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default PeruExportSearch;
